import script from "./BaseLocaLeDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseLocaLeDropdown.vue?vue&type=script&setup=true&lang=js"

import "./BaseLocaLeDropdown.vue?vue&type=style&index=0&id=60e9454e&lang=scss&scoped=true"

import exportComponent from "D:\\online\\paramedicsuz_admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60e9454e"]])

export default __exports__